import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';

// Gate for routes that need a session.
//
//   <Route element={<ProtectedRoute />}>            ... any signed-in user
//   <Route element={<ProtectedRoute requireAdmin />}> ... admins only
//
// This is a convenience, not a security boundary. Anyone can edit their own
// browser. The real enforcement is Row Level Security in the database: an
// admin-only query returns nothing for a normal user regardless of what the
// frontend lets them click.
export default function ProtectedRoute({ requireAdmin = false }) {
  const { loading, isAuthenticated, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-4 border-muted border-t-primary rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Remember where they were headed so login can send them back.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
